import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=23022dfa&scoped=true&lang=pug&"
import script from "./MultiSelect.vue?vue&type=script&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=23022dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23022dfa",
  null
  
)

export default component.exports